const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.wemaza.com';

/**
 * Retourne une URL absolue pour une image/fichier uploadé sur le backend.
 * - Si le chemin est déjà une URL complète (http/https/data), elle est retournée telle quelle.
 * - Si le chemin est relatif (ex: "uploads/avatars/123.jpg"), elle est préfixée avec l'URL du backend.
 */
export function getImageUrl(path) {
  if (!path) return '';
  if (/^(https?:|data:)/i.test(path)) return path;
  return `${API_BASE_URL}/${path.replace(/^\/+/, '')}`;
}
